import Vue from 'vue'
import * as types from './mutation-types'
import * as constants from './modal-constants'
import store from '../../../store'
import PlanVenteBrowser from '../../../components/modal/content/PlanVenteBrowser'
import TrancheForfaitTransportForm from '../../../components/modal/content/TrancheForfaitTransportForm'
import ForfaitTypeModificationWarning from '../../../components/modal/content/ForfaitTypeModificationWarning'
import ForfaitResetWarning from '../../../components/modal/content/ForfaitResetWarning'

const initialState = {
    style: {},
    title: null,
    content: null,
    cancelTitle: 'annuler',
    cancelAction: () => store.dispatch('closeModal'),
    validateTitle: 'ok',
    validateAction: () => store.dispatch('closeModal'),
    visible: false,
    warning: false,
    cache: {}
}

const state = { ...initialState }

const mutations = {
    [types.OPEN_MODAL](state) {
        state.visible = true
    },
    [types.CLOSE_MODAL](state) {
        Object.entries(initialState).forEach(([key, value]) => {
            state[key] = value
        })
    },
    [types.SET_MODAL_COMPONENT](state, component) {
        state.content = component
    },
    [types.SET_STYLE](state, style) {
        state.style = style
    },
    [types.SET_TITLE](state, title) {
        state.title = title
    },
    [types.SET_CANCEL](state, { action, title }) {
        state.cancelAction = action
        state.cancelTitle = title
    },
    [types.SET_VALIDATE](state, { title, action }) {
        state.validateAction = action
        state.validateTitle = title
    },
    [types.SET_MODAL_WARNING](state) {
        state.warning = true
    },
    [types.CLEAR_MODAL_WARNING](state) {
        state.warning = false
    },
    [types.SET_MODAL_CACHE](state, cache) {
        state.cache = {
            ...state.cache,
            ...cache
        }
    },
    [types.CLEAR_MODAL_CACHE](state) {
        state.cache = {}
    }
}

const actions = {
    openModal({ rootState, state, commit, dispatch }, content) {
        const { type } = content
        const minimumArticles = 2
        switch (type) {
            case constants.PLAN_VENTE_BROWSER_MODAL: {
                dispatch(
                    'setSelectedFilteredArticles',
                    { ...rootState.regroupements.currentRegroupement.articles }
                )
                const cleanUp = () => {
                    store.dispatch('resetFilteredArticles')
                    store.dispatch('resetPlanVente')
                    store.dispatch('closeModal')
                }
                commit(types.SET_STYLE, {
                    'min-width': '60%',
                    'min-height': '60%'
                })
                commit(types.SET_TITLE, 'Sélection des articles')
                commit(types.SET_MODAL_COMPONENT, PlanVenteBrowser)
                commit(types.SET_VALIDATE, {
                    title: 'ok',
                    action: () => {
                        const selectedArticles = rootState.articlesFilter.selected
                        if (Object.keys(selectedArticles).length < minimumArticles) {
                            Vue.toasted.error('Veuillez sélectionner plusieurs articles').goAway(1500)
                            store.dispatch('setModalWarning')
                            return
                        }
                        store.dispatch('setRegroupementArticles', selectedArticles)
                        store.dispatch('setRegroupementAttributs')
                        cleanUp()
                    }
                })
                commit(types.SET_CANCEL, {
                    title: 'annuler',
                    action: () => {
                        cleanUp()
                    }
                })
                break
            }
            case constants.TRANCHE_FORFAIT_TRANSPORT_MODAL: {
                const cleanUp = () => {
                    // TODO: Reset?
                    // store.dispatch('resetPlanVente')
                    store.dispatch('closeModal')
                }
                commit(types.SET_STYLE, {
                    'min-width': '60%',
                    'min-height': '20%'
                })
                commit(types.SET_TITLE, 'Ajouter une tranche')
                commit(types.SET_MODAL_COMPONENT, TrancheForfaitTransportForm)
                commit(types.SET_VALIDATE, {
                    title: 'ok',
                    action: () => {
                        store.dispatch('createTranche', state.cache)
                        cleanUp()
                    }
                })
                commit(types.SET_CANCEL, {
                    title: 'annuler',
                    action: () => {
                        cleanUp()
                    }
                })
                break
            }
            case constants.FORFAIT_TYPE_MODIFICATION_MODAL: {
                const cleanUp = () => {
                    store.dispatch('closeModal')
                }
                commit(types.SET_STYLE, {
                    'min-width': '60%',
                    'min-height': '20%'
                })
                commit(types.SET_TITLE, 'Changer de type de forfait de transport')
                commit(types.SET_MODAL_COMPONENT, ForfaitTypeModificationWarning)
                commit(types.SET_VALIDATE, {
                    title: 'valider',
                    action: () => {
                        store.dispatch('updateTypeForfait', state.cache)
                        cleanUp()
                    }
                })
                commit(types.SET_CANCEL, {
                    title: 'annuler',
                    action: () => {
                        cleanUp()
                    }
                })
                break
            }
            case constants.FORFAIT_RESET_MODAL: {
                const cleanUp = () => {
                    store.dispatch('closeModal')
                }
                commit(types.SET_STYLE, {
                    'min-width': '60%',
                    'min-height': '20%'
                })
                commit(types.SET_TITLE, 'Supprimer tous les forfaits de transport')
                commit(types.SET_MODAL_COMPONENT, ForfaitResetWarning)
                commit(types.SET_VALIDATE, {
                    title: 'valider',
                    action: () => {
                        store.dispatch('resetForfaitTransport', state.cache)
                        cleanUp()
                    }
                })
                commit(types.SET_CANCEL, {
                    title: 'annuler',
                    action: () => {
                        cleanUp()
                    }
                })
                break
            }
            default: {
                return
            }
        }
        commit(types.OPEN_MODAL)
    },
    closeModal({ commit }) {
        commit(types.CLOSE_MODAL)
        commit(types.CLEAR_MODAL_CACHE)
    },
    setModalWarning({ commit }) {
        commit(types.SET_MODAL_WARNING)
        setTimeout(() => commit(types.CLEAR_MODAL_WARNING), 600)
    },
    setModalCache({ commit }, cache) {
        commit(types.SET_MODAL_CACHE, cache)
    }
}

const getters = {
    modalContent: state => state.content,
    modalVisible: state => state.visible,
    modalWarning: state => state.warning,
    modalStyle: state => state.style,
    modalTitle: state => state.title,
    modalCancelTitle: state => state.cancelTitle,
    modalCancelAction: state => state.cancelAction,
    modalValidateTitle: state => state.validateTitle,
    modalValidateAction: state => state.validateAction
}

export default {
    state,
    mutations,
    actions,
    getters
}
